import { BaseMutations } from '@/store/base-mutations';
import { RepairStatuses } from '@/enums';
import { PaginationProps, SimpleEnumType, TableOptions } from '@/types';
import { Repairs } from '../../../types';
import RepairsInfoState from './state';
import { default_new_component, default_reapairs_table_opts } from '../../../services';

export default class RepairsInfoMutations extends BaseMutations<RepairsInfoState> {
  UPD_FILTER_KEY({
    key,
    value,
  }: {
    key: keyof Repairs.RepairsInfoFilters | string;
    value: unknown;
  }) {
    this.state.filters[key] = value;
  }

  // receiving and handling data from server

  TOGGLE_LOADING_REPAIRS_INFO(toggle: boolean) {
    this.state.repairs_info_loading = toggle;
  }

  SET_REPAIRS_LIST(
    repairs: Repairs.Repair[],
  ) {
    this.state.repairs_list = repairs;
  }

  SET_DEFAULT_TABLE_OPTS() {
    this.state.table_options = default_reapairs_table_opts();
  }

  SET_CLIENT_COMPANIES(companies: { id: number | string, name: string }[]) {
    this.state.client_companies = companies;
  }

  SET_OPERATION_TYPES(operation_types: { id: number | string, name: string }[]) {
    this.state.operation_types = operation_types;
  }

  SET_REPAIR_TYPES(repair_types: { id: number | string, external_id: number | string, name: string }[]) {
    this.state.repair_types = repair_types;
    // this.state.repair_types = repair_types.map((i) => ({ ...i, id: `${i.id}` }));
  }

  SET_REPAIR_STATUSES(repair_statuses: SimpleEnumType<RepairStatuses>[]) {
    this.state.repair_statuses = repair_statuses;
  }

  SET_REPAIR_DETAILS(repair_details: Repairs.DetailedInfo) {
    this.state.repair_details = repair_details;
  }

  SET_REPAIR_COMPONENTS_SET(repair_components_set: Repairs.Component[]) {
    this.state.repair_components_set = repair_components_set;
  }

  UPD_NEW_COMPONENT({ key, value }: { key: keyof Repairs.ComponentPayload; value: string }) {
    this.state.new_component[key] = value;
  }

  SET_DEFAULT_COMPONENT() {
    this.state.new_component = default_new_component();
  }

  SET_REPAIR_DIAGNOSTICS(repair_diagnostics: Repairs.Diagnostics) {
    this.state.diagnostics = repair_diagnostics;
  }

  SET_EDITABLE_DIAGNOSTICS(editable_diagnostics: Repairs.DiagnosticsPayload) {
    this.state.editable_diagnostics = editable_diagnostics;
  }

  SET_REPAIR_DIAGNOSTICS_SELECTS(selects: Repairs.DiagnosticsSelect) {
    this.state.diagnostics_selects = selects;
  }

  SET_REPAIR_STAGES(repair_stages: Repairs.Stage[]) {
    this.state.repair_stages = repair_stages;
  }

  SET_REPAIR_PRODUCTS(products: Repairs.Product[]) {
    this.state.repair_products = products;
  }

  // #TODO: remove
  SET_REPAIR_PRODUCTS_SEARCH(val: string) {
    this.state.repair_products_search = val;
  }

  // #TODO: remove
  SET_REPAIR_PRODUCTS_FOUND(products: Repairs.ProductDetails[]) {
    this.state.repair_products_found = products;
  }

  SET_REPAIR_DOCUMENTS(repair_documents: Repairs.Document[]) {
    this.state.repair_documents = repair_documents;
  }

  SET_CATALOG_PRODUCTS_TABLE_OPTIONS(opts: TableOptions) {
    this.state.catalog_products_table_options = opts;
  }

  UPD_CATALOG_PRODUCTS_TABLE_OPTIONS({ key, value }: { key: keyof TableOptions, value: unknown }) {
    this.state.catalog_products_table_options[key] = value;
  }

  UPD_CATALOG_PRODUCTS_PAGINATION_FIELD({ key, value }: { key: keyof PaginationProps, value: number }) {
    this.state.catalog_products_pagination_props[key] = value;
  }

  SET_CATALOG_PRODUCTS(catalog_products: Repairs.CatalogProduct[]) {
    this.state.catalog_products = catalog_products;
  }

  SET_CATALOG_PRODUCTS_LOADING(value: boolean) {
    this.state.catalog_products_loading = value;
  }

  UPD_CATALOG_PRODUCT_FILTER_KEY({ key, value }: { key: keyof Repairs.CatalogProductRequestFilters, value: unknown }) {
    this.state.catalog_products_filters[key] = value;
  }
}
